import { removeChar, isArray } from "coreutils-js";

export const nomarlizePath = function (path) {
  let fix_path = path.replace(/\/{1,}/g, "/");
  fix_path = removeChar(fix_path, "/", "begin_end_all");
  return fix_path;
};

export function linkTo(basename, path) {
  window.history.pushState(
    {},
    undefined,
    "/" + nomarlizePath(`${basename}/${path}`)
  );
}

export function redirectTo(url) {
  window.location.href = url;
}